import React from 'react'
import { css } from 'emotion'
import * as images from 'images'

const RewardsRightArrowButtonView = ({ disabled }) => (
  <img
    className={styles.rightArrow}
    src={images.rewardArrowRight}
    style={disabled ? { opacity: 0.5 } : {}}
    alt="Right Arrow"
  />
)

const styles = {
  rightArrow: css({
    objectFit: 'contain',
    width: '8.5rem',
    position: 'absolute',
    top: '46%',
    right: '1rem',
    transition: 'all .2s',
    '&:hover': {
      transform: 'translateX(1px)',
    },
    '&:active': {
      transform: 'translate(-1px, .5px)',
    },
  }),
}

export default RewardsRightArrowButtonView
